import Cookies from "js-cookie";

const cookieStorage = {
  getItem: <T>(key: string): T | null => {
    const value = Cookies.get(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: unknown) => {
    Cookies.set(key, JSON.stringify(value), { path: "/", expires: 2 });
  },
  removeItem: (key: string) => {
    Cookies.remove(key, { path: "/" });
  },
};

export default cookieStorage;
